<template>
    <b-container>
        {{ rowItem }}
    </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["rowItem", "modalid"],
  data() {
    return {
      form: {},
      membersSelect: [],
      membersList: [],
      spinner: false,
      disabled: false,
      error: "",
      success: false,
    };
  },
  mounted() {
    this.spinner = true;
    let accessToken = this.getGlobalData("accessToken");
    let groupId = this.rowItem.GroupId;
    this.getMemberOf(accessToken, groupId);
  },
  computed: {
    url: function () {
      return this.getUrl();
    }
  },
  methods: {
    removeMembersList() {
      let groupId = this.rowItem.GroupId;
      let groupMembersList = this.$store.getters.getGroupMembersList;
      let newList = groupMembersList.filter((item) => {
        return item.rowItem.GroupId !== groupId;
      });
      this.$store.commit("removeGroupMembersList", newList);
      if (groupMembersList.length !== newList.length) {
        this.$bvModal.hide("membersModal");
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      if (this.membersSelect.length === 0) {
        this.error = this.$t("label.noMemberChoose");
        return;
      }
      let groupMembersList = this.$store.getters.getGroupMembersList;
      let groupId = this.rowItem.GroupId;
      let find = groupMembersList.find((item) => {
        return item.rowItem.GroupId === groupId;
      });
      if (find) {
        let newList = groupMembersList.filter((item) => {
          return item.rowItem.GroupId !== groupId;
        });
        this.$store.commit("removeGroupMembersList", newList);
      }
      let obj = {
        rowItem: this.rowItem,
        members: this.membersSelect,
      };
      
      this.$store.commit("addGroupMembersList", obj);

      this.$bvModal.hide(this.modalid);

      //this.success = true;
    },
    getMemberOf(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members`;
      axios
        .get(graphEndpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            ConsistencyLevel: "eventual",
          },
        })
        .then((response) => {
          let membersList = response.data.value;
          this.membersList = membersList.map((item) => {
            return {
              value: item,
              text: item.displayName,
            };
          });

          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
};
</script>
